let timeWidget: HTMLDivElement | null = null;

export function showDebugTimeWidget(): void {
  if (timeWidget) return;

  timeWidget = document.createElement('div');
  Object.assign(timeWidget.style, {
    backgroundColor: 'grey',
    position: 'fixed',
    bottom: '0',
    left: '0',
    fontFamily: 'monospace',
    padding: '5px',
  });

  document.body.appendChild(timeWidget);

  setInterval(() => {
    if (!timeWidget) return;
    timeWidget.innerText = new Date(Date.now()).toUTCString();
  }, 200);
}
